import { render, staticRenderFns } from "./PageViews.vue?vue&type=template&id=c875a8e0&"
import script from "./PageViews.vue?vue&type=script&lang=js&"
export * from "./PageViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports